import { render, staticRenderFns } from "./DiNewGroupMail.vue?vue&type=template&id=50f7fc7e&scoped=true&"
import script from "./DiNewGroupMail.vue?vue&type=script&lang=js&"
export * from "./DiNewGroupMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7fc7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
